/* Dulcevientre — comportamiento propio (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll ---- */
  function initReveals() {
    var els = document.querySelectorAll('.dv-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dv-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('dv-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var end = parseFloat(el.getAttribute('data-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        if (reduce) { el.textContent = end + suffix; return; }
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var val = Math.floor((1 - Math.pow(1 - p, 3)) * end);
          el.textContent = val + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = end + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Galería de la página de producto ---- */
  function initGallery() {
    var gallery = document.querySelector('[data-dv-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-dv-main-img]');
    var thumbs = gallery.querySelectorAll('[data-dv-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var root = document.querySelector('[data-dv-variants]');
    if (!root) return;
    var dataEl = document.getElementById('dv-variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var swatches = root.querySelectorAll('[data-dv-swatch]');
    var idInput = root.querySelector('[data-dv-variant-id]');
    var priceEl = root.querySelector('[data-dv-price]');
    var addBtn = root.querySelector('[data-dv-add]');
    var soldout = root.querySelector('[data-dv-soldout]');
    var selected = {};

    // Inicializa con la primera variante disponible
    var optionNames = root.getAttribute('data-dv-variants').split('||');

    function findVariant() {
      return variants.find(function (v) {
        return optionNames.every(function (name, i) {
          return v.options[i] === selected[name];
        });
      });
    }

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' €';
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (v.available) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito'; }
        if (soldout) soldout.style.display = 'none';
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
        if (soldout) soldout.style.display = 'block';
      }
    }

    swatches.forEach(function (s) {
      var name = s.getAttribute('data-option-name');
      var value = s.getAttribute('data-option-value');
      if (s.classList.contains('is-active')) selected[name] = value;
      s.addEventListener('click', function () {
        selected[name] = value;
        root.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        update();
      });
    });
    update();
  }

  function boot() {
    if (window.__dvBooted) return;
    window.__dvBooted = true;
    initReveals();
    initCounters();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
